import { CloudyContactCard } from './cloudy-copiable-contact-card'

export function WhatsappCallCloudyCard() {
  return (
    <CloudyContactCard title="Appel Whatsapp">
      <div className="flex w-full cursor-not-allowed items-center gap-3 rounded-lg opacity-80">
        <img alt="Whatsapp" className="h-8 w-8" src="/icons/whatsapp.svg" />
        <p className="flex flex-1 text-sm font-medium text-white">Nous appeler via Whatsapp</p>
        <span className="rounded-full bg-white/20 px-2 py-1 text-xs font-semibold text-white">
          Bientôt disponible
        </span>
      </div>
    </CloudyContactCard>
  )
}

export function WhatsappMessageCloudyCard() {
  return (
    <CloudyContactCard title="Message Whatsapp">
      <div className="flex w-full cursor-not-allowed items-center gap-3 rounded-lg opacity-80">
        <img alt="Whatsapp" className="h-8 w-8" src="/icons/whatsapp.svg" />
        <p className="flex flex-1 text-sm font-medium text-white">
          Envoyer un message via Whatsapp
        </p>
        <span className="rounded-full bg-white/20 px-2 py-1 text-xs font-semibold text-white">
          Bientôt disponible
        </span>
      </div>
    </CloudyContactCard>
  )
}
